import React from 'react';
import PropTypes from 'prop-types';
import Popup from '../../Popup';
import styles from './rosterLockedPopUp.scss';

const RosterLockedPopUp = props => {
    const {
        onCloseClick,
        lockEndDate,
    } = props;

    return (
        <Popup
            className="popup-md"
            popUpClassName={styles.popupConfig}
            onCloseClick={onCloseClick}
            config={{
                fullScreen: false,
                noPadding: true,
                gradient: true,
                scrollable: false,
                noHeader: true,
            }}
        >
            <div className={styles.popupContainer}>
                <p className={styles.popupHeader}>
                    Unable to Edit Roster
                </p>
                <p className={styles.popupDetails}>
                    College rosters are locked for editing until the end of the season{lockEndDate ? ` on ${lockEndDate}` : ''}. If you need to make changes to your roster, please contact our Customer Support team by clicking <a href="https://support.utrsports.net/support/tickets/new" target="_blank" rel="noopener noreferrer" className={styles.supportLink}>here</a>.
                </p>
                <div className={styles.buttonContainer}>
                    <div className={styles.buttonWrapper}>
                        <button
                            onClick={onCloseClick}
                            type="button"
                            className={`btn btn-primary text-uppercase btn-block ${styles.closeButton}`}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

RosterLockedPopUp.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    lockEndDate: PropTypes.string,
};

RosterLockedPopUp.defaultProps = {
    lockEndDate: null,
};

export default RosterLockedPopUp;
